import React from "react";

interface EditLinkProps {
  id: string;
  onClick: () => void;
}

const EditLink = ({ id, onClick }: EditLinkProps) => {
  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
      className="panel__summary-link"
      id={id}
    >
      EDIT
    </a>
  );
};

EditLink.defaultProps = {};

export default EditLink;
